module.exports = __webpack_public_path__ + "static/images/d6b1502419cfea6bf0d44d896f26f509.svg";